import { LngLatBounds } from '@nbai/nbmap-gl';

export function parseLatLng(latLong: string): [number, number] {
  const [lat, lng] = latLong.split(',').map(s => parseFloat(s.trim()));
  return [lng, lat];
}

export function filterValidCoords(coords: [number, number][]): [number, number][] {
  return coords.filter(([lng, lat]) =>
    !isNaN(lng) && !isNaN(lat) &&
    lng >= -180 && lng <= 180 &&
    lat >= -90  && lat <= 90
  );
}

export function buildBounds(coords: [number, number][]): LngLatBounds {
  const bounds = new LngLatBounds();
  coords.forEach(coord => bounds.extend(coord));
  return bounds;
}

export function isBoundsValid(bounds: LngLatBounds): boolean {
  try {
    return !!(bounds.getNorthEast() && bounds.getSouthWest());
  } catch {
    return false;
  }
}